import { useQuery } from '@tanstack/react-query';
import type { DeploymentMode, FeatureFlags, LicenseTier } from '@tokenforge/shared';
import { apiFetch } from '../../api/client';

export interface SaasSessionResponse {
  authenticated: boolean;
  membershipRole: string | null;
  licenseTier: LicenseTier | null;
  scopes: string[];
  tenant: {
    id: string;
    enterpriseId: string;
    name: string;
    licenseTier: LicenseTier;
    status: 'active' | 'suspended';
  } | null;
  user: {
    id: string;
    email: string;
    name: string | null;
    role: string;
    status: string;
    departmentIds: string[];
  } | null;
  featureFlags: FeatureFlags | null;
  deploymentMode: DeploymentMode;
  registrationEnabled: boolean;
}

export function useSaasSession(enabled = true) {
  return useQuery({
    queryKey: ['saas-session'],
    queryFn: () => apiFetch<SaasSessionResponse>('/saas/session'),
    retry: false,
    enabled,
  });
}
